import { APIForm } from './_api-form.js';
class MailRegister extends APIForm {
  constructor() {
    super();
    this._successRedirectUrl = null;
    this._confirmationElement = null;
    this._inputField = null;
    this._submitButton = null;
    this._confirmationLabel = null;
  }
  connectedCallback() {
    super.connectedCallback();
    // Find the confirmation element when component is connected
    this._confirmationElement = this._form.querySelector('[data-role="confirmation"]');
    // Find the input field and submit button
    this._inputField = this._form.querySelector('input[name="email"]');
    this._submitButton = this._form.querySelector('button[type="submit"]');

    // Store the confirmation label if available
    if (this._submitButton) {
      this._confirmationLabel = this._submitButton.getAttribute('data-confirmation-label');
    }

    // Check localStorage for previous subscription
    this._checkPreviousSubscription();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  _getDefaultEndpoint() {
    return "/wp-json/api/v1/newsletter/register";
  }
  _handleSuccess(data) {
    // Save subscription to localStorage
    if (this._inputField && this._inputField.value) {
      localStorage.setItem('newsletterSubscribed', 'true');
      localStorage.setItem('mailNewsletterSubscribed', this._inputField.value);
    }

    // Show the confirmation message
    if (this._confirmationElement) {
      // Disable the input field and submit button
      this._disableFormControls();

      // Show the confirmation message
      this._confirmationElement.removeAttribute('hidden');

      // Update the button text if confirmation label is available
      if (this._submitButton && this._confirmationLabel) {
        this._submitButton.textContent = this._confirmationLabel;
      }
    }

    // Call the parent method to handle any other success behaviors
    super._handleSuccess(data);
  }
  _disableFormControls() {
    // Disable the input field
    if (this._inputField) {
      this._inputField.disabled = true;
    }

    // Disable the submit button
    if (this._submitButton) {
      this._submitButton.disabled = true;
    }
  }
  _checkPreviousSubscription() {
    const newsletterSubscribed = localStorage.getItem('newsletterSubscribed');
    const subscribedEmail = localStorage.getItem('mailNewsletterSubscribed');
    if (newsletterSubscribed === 'true' && subscribedEmail) {
      // Fill in the email field with the previously subscribed email
      if (this._inputField) {
        this._inputField.value = subscribedEmail;
      }

      // Disable form controls
      this._disableFormControls();

      // Update button text if confirmation label is available
      if (this._submitButton && this._confirmationLabel) {
        this._submitButton.textContent = this._confirmationLabel;
      }
    }
  }
}

// Register the custom element
customElements.define('mail-register', MailRegister);